export const Permissoes = {
  PERFIL: "Profile",
  TELA: "Page",
  CAMPO: "Field",
  PERMISSOES: "Permissions",
};
